<template>
  <nav class="wrn-navbar wrn-bg-black">
    <div class="wrn-row wrn-container-fluid">
      <div class="wrn-c-12 wrn-text-center">
        <BaseText
          as="strong"
          size="sm"
          class="navbar-title text-p6-semibold"
          :color="NebraskaColors.textNegative"
        >
          <span v-if="isRegisterRejected">
            {{ getString('account_update_alert_title_rejected') }}
          </span>
          <span v-else>({{ getString('account_update_alert_title') }})</span>
          <span v-if="hasRegulationUpdate">
            {{ getString('dash_menu_my_account_update') }}
          </span>
        </BaseText>
        <BaseText size="sm" class="wrn-m-b-05 wrn-color-gray-2">
          {{ getString('account_update_alert_subtitle') }}
        </BaseText>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getString } from '@/modules/common/helpers/resources';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText } from '@warrenbrasil/nebraska-web';

@Component({
  components: { BaseText }
})
export default class UnderApprovalNotification extends Vue {
  @Prop({ type: Boolean, default: false, required: true })
  private isRegisterRejected!: boolean;

  @Prop({ type: Boolean, default: false, required: true })
  private hasRegulationUpdate!: boolean;

  private getString = getString;

  get NebraskaColors() {
    return NebraskaColors;
  }
}
</script>

<style lang="less" scoped>
.navbar-title {
  font-weight: 700;
}
</style>
